import { render, staticRenderFns } from "./button-shine.vue?vue&type=template&id=5b4812f4&scoped=true&"
var script = {}
import style0 from "./button-shine.vue?vue&type=style&index=0&id=5b4812f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4812f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b4812f4')) {
      api.createRecord('5b4812f4', component.options)
    } else {
      api.reload('5b4812f4', component.options)
    }
    module.hot.accept("./button-shine.vue?vue&type=template&id=5b4812f4&scoped=true&", function () {
      api.rerender('5b4812f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/button-shine.vue"
export default component.exports